module.exports = __webpack_public_path__ + "static/media/luckyThree-1.1521e6c0.png";